<mat-card class="card">
    <div class="card-header">
        <fa-icon class="icon" icon="key"></fa-icon>
        <h3>Lizenzen</h3>
    </div>

    <ngx-simplebar class="clickable-list-container">
        <ul class="clickable-list" *ngIf="!Editing && DisplayUser$ | async as user">
            <ng-container *ngFor="let product of user.products">
                <li class="custom-clickable-list-item">
                    <a class="clickable-list-item-link">
                        <div class="clickable-list-item-content">
                            <div class="contactperson-img mat-card-avatar">
                                <fa-icon icon="key" size="lg"></fa-icon>
                            </div>
                            <p class="name">
                                {{product.Name}}
                            </p>
                        </div>
                    </a>
                </li>
                <mat-divider></mat-divider>
            </ng-container>
            <li *ngIf="!user.ProductIds || user.ProductIds.length < 1" class="custom-clickable-list-item">
                <a class="clickable-list-item-link">
                    <div class="clickable-list-item-content">
                        <p class="name">
                            Keine Lizenz zugeteilt
                        </p>
                    </div>
                </a>
            </li>
        </ul>
        <ul class="clickable-list" *ngIf="Editing && Products as products">
            <ng-container *ngFor="let product of products">
                <li class="clickable-list-item">
                    <button mat-button class="clickable-list-item-link"
                            [disabled]="product.Available < 1 && !HasProduct(product.Id)"
                            (click)="SetLicense(product, User.Email, EmployeeId)">
                        <div class="clickable-list-item-content">
                            <div class="contactperson-img mat-card-avatar">
                                <fa-icon [icon]="HasProduct(product.Id) ? 'check' : 'times'" size="lg"></fa-icon>
                            </div>
                            <p class="name">
                                {{product.Name}} {{product.Available ? '(' + product.Available + ' verfügbar)' : ''}}
                            </p>
                        </div>
                    </button>
                </li>
                <mat-divider></mat-divider>
            </ng-container>
        </ul>
    </ngx-simplebar>
</mat-card>
